// NPM Imports
import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

// Internal Imports
import { GlobalUtils, OppoUtils } from "../../../utils";
import { DASHBOARD, PATHS, PIPELINE } from "../../../constants";

// Destructuring
const { DOCUMENTS_PATH } = PATHS;
const { DOCUMENT_STATUS_HASMAP } = PIPELINE;
const { DOCUMENT_TYPES_HASMAP } = DASHBOARD;
const {
  getDocStatusClassName,
  decideDeadlineDateClassName,
  decideDeadlineDaysCount,
} = OppoUtils;

const AssetsOpportunityItem = props => {
  const {
    title,
    type: { name: docType } = {},
    doc_no: docNo,
    deadline_date: deadlineDate,
    revision_no: revisionNumber,
    // meta_values: { start_date: docStartDate, stop_date: docEndDate } = {},
    created_by: { name: ownerName, image_url: ownerProfileImageUrl } = {},
    updated_at: docLastEdited,
    status: docStatus,
  } = props;

  const _getDocumentShortName = documentName => {
    if (documentName && documentName.length >= 28) {
      return `${documentName.slice(0, 28)}...`;
    }
    return documentName;
  };

  const dlDate = GlobalUtils.formatDate(deadlineDate, "lll");
  const currentDate = new Date();
  const deadlineLeftHours = moment(dlDate).diff(moment(currentDate), "hours");

  return (
    <Link
      to={`${DOCUMENTS_PATH}/${docNo}`}
      onClick={() =>
        GlobalUtils.writeDataToLocalStorage("documentPageSource", "assets")
      }
      className="assetsopportunityitem-doclink">
      <div className="assetsopportunityitem-card-body">
        <div className="assetstable-doc-title">
          <div className="assetstable-col assetstable-doc-wrapper">
            <span className="assetsopportunityitem-fileicon">
              <FontAwesomeIcon icon={["fal", "file-alt"]} />
            </span>
            <span>
              <span className="assetsopportunityitem-documentname">
                {_getDocumentShortName(title)}
              </span>
              <span className="assetsopportunityitem-docno">
                {docNo}
                {revisionNumber > 0 && (
                  <span className="assetsopportunityitem-document-revision-label">
                    Revision {revisionNumber}
                  </span>
                )}
              </span>
            </span>
          </div>
        </div>
        <div className="assetstable-col assetstable-doc-type">
          <Tooltip placement="top" overlay={docType}>
            <span className="assetsopportunityitem-doctype">
              {DOCUMENT_TYPES_HASMAP[docType]
                ? DOCUMENT_TYPES_HASMAP[docType]
                : "-"}
            </span>
          </Tooltip>
        </div>
        {/* <div className="assetstable-doc-startdate">
        <span>{GlobalUtils.formatDate(docStartDate, "ll")}</span>
      </div> */}
        <div className="assetstable-col assetstable-doc-owner">
          <span className="assetsopportunityitem-document-ownerimage">
            <Tooltip placement="top" overlay={ownerName || "-"}>
              <img alt="Revv" src={ownerProfileImageUrl} />
            </Tooltip>
          </span>
        </div>
        <div className="assetstable-col assetstable-doc-enddate">
          {deadlineDate ? (
            <Tooltip
              placement="bottom"
              overlay={decideDeadlineDaysCount(deadlineLeftHours)}>
              <span
                className={`assetsopportunityitem-deadline-date ${decideDeadlineDateClassName(
                  deadlineLeftHours,
                )}`}>
                {GlobalUtils.formatDate(deadlineDate, "ll")}
              </span>
            </Tooltip>
          ) : (
            <span className="text-align-center">-</span>
          )}
        </div>
        <div className="assetstable-col assetstable-doc-lastedit">
          <span>{GlobalUtils.formatDate(docLastEdited, "ll")}</span>
        </div>
        <div className="assetstable-col assetstable-doc-status">
          <div className="assetstable-doc-statustitle">
            <span
              className={`status-icon assets-${getDocStatusClassName(
                docStatus,
              )} assetsopportunityitem-status`}
            />
            {DOCUMENT_STATUS_HASMAP[docStatus]}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default AssetsOpportunityItem;



// WEBPACK FOOTER //
// ./src/components/AssetsWrapper/AssetsOpportunityItem/index.js